/* eslint @typescript-eslint/no-var-requires: "off" */
/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/Vuetify'
import i18n from './i18n'

require('@/plugins/city-map/Index')
require('@/plugins/Widget')
require('@/services/Storage')
require('@/services/Widget')

Vue.config.productionTip = (process.env.VUE_APP_NODE_ENV === 'develop')
Vue.config.devtools = (process.env.VUE_APP_NODE_ENV === 'develop')
Vue.config.silent = (process.env.VUE_APP_NODE_ENV !== 'develop')

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
